// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__Us44O","content":"Modal_content__t88Cx","body":"Modal_body__dZA2Z","list":"Modal_list__Yem7C","footer":"Modal_footer__y4X3q"};